import { useState, useEffect } from "react";
import axios from "axios";
import { companies } from "../utils/data";
import { Role_Responder_VideoType } from "../utils/types";

export default function useFetch(companyName: string = "sls") {
  const [data, setData] = useState<Role_Responder_VideoType[]>([]);

  const getURL = (companyName: string) => {
    const companyLoaded = companies.filter((each) => each.name === companyName);
    return companyLoaded[0].url;
  };

  const url = getURL(companyName);
  useEffect(() => {
    axios
      .get(url)
      .then((res: any) => {
        setData(res.data.videos.reverse());
      })
      .catch((err: any) => console.log(err));
  }, [url]);
  return data;
}
